import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import RecentActivityBlock from "@/components/RecentActivityBlock";
import { Activity, Briefcase, Receipt, ShieldCheck } from "lucide-react";

const FILTERS = [
  { key: "missions", label: "Missions", icon: Briefcase },
  { key: "invoices", label: "Factures", icon: Receipt },
  { key: "validations", label: "Validations", icon: ShieldCheck },
];

export default function RecentActivity() {
  // All filters on by default — toggling off hides that group from the feed.
  const [active, setActive] = useState(() => new Set(FILTERS.map((f) => f.key)));

  // Mark the feed as seen as soon as the page is opened so the sidebar badge clears.
  useEffect(() => {
    api.post("/recent-activity/mark-seen").catch(() => {});
  }, []);

  const toggle = (k) => {
    setActive((prev) => {
      const next = new Set(prev);
      if (next.has(k)) next.delete(k); else next.add(k);
      // Always keep at least one toggle on
      if (next.size === 0) next.add(k);
      return next;
    });
  };

  return (
    <div className="p-4 md:p-8 lg:p-12 max-w-[1100px]" data-testid="recent-activity-page">
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-3 font-mono">Audit log</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight flex items-center gap-3">
          <Activity size={28} className="text-brand-orange" /> Recent activity
        </h1>
        <p className="text-zinc-500 mt-3 max-w-2xl">
          Journal chronologique des derniers events opérationnels. Filtrez par type pour cibler une catégorie ;
          chaque ligne renvoie directement vers la mission ou la facture concernée.
        </p>
      </div>

      <div className="mb-6 flex flex-wrap gap-2" data-testid="recent-activity-filters">
        {FILTERS.map(({ key, label, icon: Icon }) => {
          const on = active.has(key);
          return (
            <button
              key={key}
              onClick={() => toggle(key)}
              data-testid={`filter-${key}`}
              data-active={on}
              className={`inline-flex items-center gap-2 px-4 h-9 rounded-full border text-sm font-medium transition-all ${
                on
                  ? "bg-brand-navy text-white border-brand-navy shadow-sm"
                  : "bg-white text-zinc-600 border-zinc-200 hover:border-brand-navy hover:text-brand-navy"
              }`}
            >
              <Icon size={14} /> {label}
            </button>
          );
        })}
      </div>

      <RecentActivityBlock activeGroups={active} />
    </div>
  );
}
